import { useState, useEffect, useContext } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import logo from '../assets/logo_bg.webp'
import scrollContext from '../contexts/scrollContext'
import { FaArrowRight } from "react-icons/fa6"
import { RxHamburgerMenu } from "react-icons/rx";
import ResponsiveMenu from './ResponsiveMenu'
import { CgMenuRight } from "react-icons/cg";
import LocationMenu from './LocationMenu'
import '../styles/promo-ticker.css'
import { useTr, usePathLang } from '../lib/i18n'
import { NAV_CATEGORIES, navCategoryPath, homePath, contactPath, aboutPath, PROMO_TEXT, switchLangPath } from '../lib/ru'

const Navbar = () => {
  const [showRespMenu, setShowRespMenu] = useState(false)
  const [showLocation, setShowLocation] = useState(false)
  const [isFixedVisible, setIsFixedVisible] = useState(false)
  const { enableScroll, disableScroll } = useContext(scrollContext)
  const [saleType, setSaleType] = useState(null);
  const location = useLocation()
  const lang = usePathLang()
  const tr = (ro, ru) => (lang === 'ru' ? ru : ro)
  const promo = PROMO_TEXT[lang]

  useEffect(() => {
  setSaleType(location.pathname.endsWith('/chirie') || location.pathname.endsWith('/arenda') ? '2' : '')
}, [location.pathname])

  useEffect(() => {
    if (!showRespMenu) {
      enableScroll()
    } else {
      disableScroll()
    }
  }, [showRespMenu])

  useEffect(() => {
    if (!showLocation) {
      enableScroll()
    } else {
      disableScroll()
    }
  }, [showLocation])

  useEffect(() => {
    const handleScroll = () => {
      setIsFixedVisible(window.scrollY > 80)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const linkBase =
    "font-poppins text-[18px] font-[500] tracking-wider transition-colors duration-100 ease-in"

  const categoryLinks = (saleTypeVal) =>
    NAV_CATEGORIES.map((c) => [
      tr(c.label, c.ruLabel),
      navCategoryPath(lang, c.base, saleTypeVal),
    ])

  const NavContent = () => (
    <nav className="sm:container sm:mx-auto flex justify-between px-[12px] lg:py-[5px] items-center">
      <NavLink to={homePath(lang)} className="inline-block">
        <img
          src={logo}
          alt={tr('LVG Imob - Companie imobiliară - Logo', 'LVG Imob - Компания недвижимости - Логотип')}
          width="115" height="65" className="h-[65px] lg:h-[78px] rounded-[5px]"
        />
      </NavLink>

      <ul className="hidden lg:flex gap-[35px] xl:gap-[55px] text-[#181616]">
        <li className="group relative">
          <NavLink to={homePath(lang)} end className={({ isActive }) => `${linkBase} ${isActive ? "text-[#d5ab63]" : "hover:text-[#d5ab63]"}` }>
            {tr('Acasă', 'Главная')}
          </NavLink>
          <span className="block absolute -bottom-1 left-0 w-0 h-[1.5px] opacity-[0.8] bg-[#d5ab63] transition-all duration-150 ease-in group-hover:w-full"></span>
        </li>

        <li className="group relative">
          <NavLink to={lang === 'ru' ? '/ru/kvartiry/arenda' : '/apartamente/chirie'} className={`${linkBase} ${saleType === '2' ? 'text-[#d5ab63]' : 'hover:text-[#d5ab63]'}`}>
            {tr('Chirie', 'Аренда')}
          </NavLink>
          <span className="block absolute -bottom-1 left-0 w-0 h-[1.5px] opacity-[0.8] bg-[#d5ab63] transition-all duration-150 ease-in group-hover:w-full"></span>
          <div className="absolute left-[-30px] top-full pt-[12px] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 ease-in z-[60]">
            <div className="bg-white shadow-lg border border-gray-200 rounded-[5px] py-[6px] min-w-[240px]">
              {categoryLinks(2).map(([label, to]) => (
                <NavLink key={to} to={to} className="block px-[18px] py-[9px] text-[15px] font-body text-[#181616] hover:bg-gray-100 hover:text-[#d5ab63] transition-colors duration-100 ease-in">
                  {label}
                </NavLink>
              ))}
            </div>
          </div>
        </li>

        <li className="group relative">
          <NavLink to={lang === 'ru' ? '/ru/kvartiry/prodazha' : '/apartamente'} className={`${linkBase} ${saleType === '1' ? 'text-[#d5ab63]' : 'hover:text-[#d5ab63]'}`}>
            {tr('Vânzare', 'Продажа')}
          </NavLink>
          <span className="block absolute -bottom-1 left-0 w-0 h-[1.5px] opacity-[0.8] bg-[#d5ab63] transition-all duration-150 ease-in group-hover:w-full"></span>
          <div className="absolute left-[-30px] top-full pt-[12px] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 ease-in z-[60]">
            <div className="bg-white shadow-lg border border-gray-200 rounded-[5px] py-[6px] min-w-[240px]">
              {categoryLinks(1).map(([label, to]) => (
                <NavLink key={to} to={to} className="block px-[18px] py-[9px] text-[15px] font-body text-[#181616] hover:bg-gray-100 hover:text-[#d5ab63] transition-colors duration-100 ease-in">
                  {label}
                </NavLink>
              ))}
            </div>
          </div>
        </li>

        <li className="group relative">
          <NavLink to={aboutPath(lang)} className={({ isActive }) => `${linkBase} ${isActive ? "text-[#d5ab63]" : "hover:text-[#d5ab63]"}`}>
            {tr('Despre noi', 'О нас')}
          </NavLink>
          <span className="block absolute -bottom-1 left-0 w-0 h-[1.5px] opacity-[0.8] bg-[#d5ab63] transition-all duration-150 ease-in group-hover:w-full"></span>
        </li>

        <li className="group relative">
          <NavLink to={contactPath(lang)} className={({ isActive }) => `${linkBase} ${isActive ? "text-[#d5ab63]" : "hover:text-[#d5ab63]"}`}>
            {tr('Contacte', 'Контакты')}
          </NavLink>
          <span className="block absolute -bottom-1 left-0 w-0 h-[1.5px] opacity-[0.8] bg-[#d5ab63] transition-all duration-150 ease-in group-hover:w-full"></span>
        </li>
      </ul>

      <div className="hidden lg:flex gap-[20px] xl:gap-[35px] items-center">
        <CgMenuRight
         onClick={() => setShowLocation(true)}
         className='text-4xl transition-colors duration-100 ease-in cursor-pointer text-[#181616] hover:text-[#d5ab63]'/>

        <div>
          <NavLink
            to={switchLangPath(location.pathname)}
            className="flex items-center uppercase font-[500] text-[14px] px-[20px] py-[18px] rounded-[5px] transition-all duration-100 ease-in border-[1px] border-gray-300 text-[#181616] hover:bg-gray-300"
          >
            <span>{location.pathname.startsWith('/ru') ? 'RO' : 'RU'}</span>
          </NavLink>
        </div>

        <div>
          <NavLink to={lang === 'ru' ? '/ru/cerere' : '/cerere'}
            className={`flex gap-[10px] items-center uppercase font-[500] text-[14px] px-[30px] py-[18px] rounded-[5px] transition-all duration-100 ease-in border-[1px] border-gray-300 text-[#181616] hover:bg-gray-300`}
          >
            <span>{tr('Vreau să vând', 'Хочу продать')}</span>
            <FaArrowRight className="text-lg text-[#d5ab63]" />
          </NavLink>
        </div>
      </div>

      <RxHamburgerMenu  className='lg:hidden text-4xl cursor-pointer' onClick={() => setShowRespMenu(true)}/>
    </nav>
  )

  return (
    <>
      <header className="font-body bg-white w-full relative z-10 shadow-md">
        {NavContent()}
      </header>

      <div className="promo-ticker" aria-label={tr('Credit ipotecar prin recomandarea LVG Imob', 'Ипотечный кредит по рекомендации LVG Imob')}>
        <div className="promo-ticker-track">
          {[0, 1].map((group) => (
            <div key={group} className="promo-ticker-group" aria-hidden={group === 1 ? 'true' : undefined}>
              {[0, 1, 2].map((item) => {
                const [before, rest] = promo.full.split(promo.highlight);
                return (
                  <a
                    key={item}
                    href={lang === 'ru' ? "https://ipoteca.lvgimob.md/ru/" : "https://ipoteca.lvgimob.md/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="promo-ticker-item font-body"
                  >
                    <span>{before}<span className="promo-ticker-highlight">{promo.highlight}</span>{rest}</span>
                    <span className="promo-ticker-dot">•</span>
                  </a>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <header className={`font-body bg-white w-full fixed top-0 left-0 z-50 shadow-md transition-transform duration-300 ease-in-out ${isFixedVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
        {NavContent()}
      </header>

      <ResponsiveMenu showRespMenu={showRespMenu} setShowRespMenu={setShowRespMenu} saleType={saleType}/>
      <LocationMenu showLocation={showLocation} setShowLocation={setShowLocation} />
    </>
  )
}

export default Navbar
